import React from 'react';
import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import { Paperclip, X } from 'react-feather';
import { IAttachmentItem } from './types';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        cursor: 'pointer',
        paddingRight: 15,
        paddingLeft: 15,
        padding: 5,
    },
    icon: {
        marginRight: 25,
        width: 20,
    },
    delete: {
        marginLeft: 5,
        width: 20,
        color: theme.palette.error.main,
    },
}));

export const AttachmentItem = ({
    attachment,
    files,
    setFiles,
    ...props
}: IAttachmentItem) => {
    const classes = useStyles();

    const attachments = files || [];

    const handleRemove = () => {
        const currentAttachment = `${attachment.name}-${attachment.size}`;
        let response = attachments.filter(
            (item) => `${item.name}-${item.size}` !== currentAttachment
        );

        setFiles(response);
    };

    return (
        <Box
            display="flex"
            alignItems="center"
            className={classes.root}
            {...props}
        >
            <Paperclip className={classes.icon} />
            <Typography variant="h6" color="textSecondary">
                {attachment.name}
            </Typography>
            <X className={classes.delete} onClick={handleRemove} />
        </Box>
    );
};
